import { BaseLogApi } from './api.base';

export class CloudLogApi extends BaseLogApi {

}
